import React from 'react';
import { observer } from 'mobx-react';
import { Layout } from 'antd';
import { MainUrlManager } from './MainUrlManager';
import { useComponent } from './PagesMap';
import { AppStatus, AppSystem } from '../interfaces';
import { useAppSystem, useAuthAppStatus, usePagesStoreCurrentComponent, useProfile } from '../hooks';
import { Catcher, LineSpinner, MainHeader, MenuInline, TicketingSystem } from '../Components';
import { MenuHorizontal } from '../Components/MenuHorizontal';
import Styles from './m_main.less';

const { Header, Content } = Layout;
export const MainView: React.FC = observer(() => {
    const appStatus = useAuthAppStatus();
    const appSystem = useAppSystem();
    const { routeName } = usePagesStoreCurrentComponent();
    const ShowComponent = useComponent(routeName);
    const { helpDeskEnabled } = useProfile();

    return (
        <Catcher>
            <MainUrlManager />
            {appStatus === AppStatus.READY || appStatus === AppStatus.ACCEPT_POLICY ? (
                <main>
                    {helpDeskEnabled ? <TicketingSystem /> : null}
                    <Layout className={Styles.layoutMain}>
                        <Header className={Styles.header}>
                            <LineSpinner />
                            <MainHeader />
                        </Header>
                        <Layout className={Styles.layoutContent}>
                            {appSystem === AppSystem.OCS ? (
                                <MenuInline className={Styles.content} />
                            ) : (
                                <MenuHorizontal />
                            )}
                            <Content
                                className={appSystem === AppSystem.OCS ? Styles.content : Styles.horizontalContent}
                                id="mainContent"
                            >
                                {ShowComponent}
                            </Content>
                        </Layout>
                    </Layout>
                </main>
            ) : (
                <>{ShowComponent}</>
            )}
        </Catcher>
    );
});
